const productImageData = {
  vegetable: {
    all: "https://t3.ftcdn.net/jpg/00/47/14/34/240_F_47143409_j3EkutIric45p2ulxp6O8rXTeXimnIWN.jpg",
    onion:
      "https://www.jiomart.com/images/product/original/590003516/potato-per-kg-product-images-o590003516-p590003516-0-202203170642.jpg?im=Resize=(420,420)s",
    potato:
      "https://www.jiomart.com/images/product/original/590003516/potato-per-kg-product-images-o590003516-p590003516-0-202203170642.jpg?im=Resize=(420,420)",
    carrot:
      "https://www.bigbasket.com/media/uploads/p/m/10000270_14-fresho-carrot-ooty.jpg",
    tomato:
      "https://www.jiomart.com/images/product/original/590003517/tomato-1-kg-product-images-o590003517-p590003517-0-202203170629.jpg?im=Resize=(420,420)",
    corn: "https://www.jiomart.com/images/product/original/590008027/sweet-corn-2-pcs-approx-500-g-720-g-product-images-o590008027-p590008027-0-202204262007.jpg?im=Resize=(420,420)",
    cauliflower:
      "https://www.jiomart.com/images/product/original/590003537/cauliflower-1-pc-approx-600-g-1000-g-product-images-o590003537-p590003537-0-202203170515.jpg?im=Resize=(420,420)",
  },
  fruit: {
    all: "https://t4.ftcdn.net/jpg/06/49/58/51/240_F_649585198_20Dixjy3JNkv71uqX2lVx7qRm1rSSsr0.jpg",
    orange:
      "https://www.jiomart.com/images/product/original/599991197/orange-navel-premium-imported-6-pc-approx-1-15-kg-1-38-kg-product-images-o599991197-p591021552-0-202304281807.jpg?im=Resize=(360,360)",
    mango:
      "https://t4.ftcdn.net/jpg/01/87/58/89/240_F_187588972_hnUTnlueJCTtpyJrNnAQzI3eW2v8StW0.jpg",
    apple:
      "https://t4.ftcdn.net/jpg/00/59/96/75/240_F_59967553_9g2bvhTZf18zCmEVWcKigEoevGzFqXzq.jpg",
    pineapple:
      "https://t3.ftcdn.net/jpg/00/34/29/82/240_F_34298231_hW5fpxuvixAkCNZa3eGk7fXp6AI5XxM5.jpg",
    banana:
      "https://t4.ftcdn.net/jpg/01/97/39/15/240_F_197391573_KVRuMoQKX0Yti6wYpuibYuScW1iGE74O.jpg",
    strawberry:
      "https://t4.ftcdn.net/jpg/01/26/92/23/240_F_126922352_EmYCsPhTG1Dww3o2mnfb6Y3C4ex1u7Vz.jpg",
    watermelon:
      "https://t4.ftcdn.net/jpg/02/72/70/19/240_F_272701969_W72GdoiiuXPBF1qRIRWZzQDBYrhOuUdG.jpg",
  },

  flours: {
    all: "https://t3.ftcdn.net/jpg/00/89/25/14/240_F_89251488_DW2gcVF1NV93Xf0v1d4zMl1DsAxCNXAQ.jpg",
  },
  masala: {
    all: "https://t3.ftcdn.net/jpg/06/90/34/26/240_F_690342678_AmakIiiqgNqYyMjMTCHTowyNzjZhVnGU.jpg",
  },

  rice: {
    all: "https://t4.ftcdn.net/jpg/00/96/54/43/240_F_96544334_KXmOaL6dI66orTmAQFqwijiy5nldktVu.jpg",
  },
  dal: {
    all: "https://t4.ftcdn.net/jpg/04/18/24/01/240_F_418240152_2baBvjZgwwzQow1BdKC4GgJD1nqrVPaN.jpg",
  },
};

export default productImageData;
